import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { bindCommentFormShortcuts } from "~/recipal-app/controllers/shared/comments.js";
import { once } from "~/jose_modern/once.js";

const scan = (container) => {
  bindCommentFormShortcuts(container);
};

const bindAddCostButton = (container) => {
  const button = container.querySelector("[data-ingredient-cost-create-button]");
  if (!button) return;

  once(button, "add-cost-button-click", () => {
    button.addEventListener("click", () => {
      const buttonContainer = button.closest("[data-ingredient-cost-create-button-container]");
      const form = document.querySelector(
        "[data-partial='ingredients/ingredient_cost_create_form']"
      );

      if (buttonContainer && form) {
        buttonContainer.hidden = true;
        form.hidden = false;
      }
    });
  });
};

onViewLoad("ingredients#costs", () => {
  scan(document);
  document.addEventListener("partial:replace", (ev) => scan(ev.container));
  document.addEventListener("partial:add", (ev) => scan(ev.container));
  bindAddCostButton(document);
});
